export default "__VITE_ASSET__7dc5b6a4__"